/** @jsxImportSource @emotion/react */
// import styled from "@emotion/styled";
// import { Navigate } from "react-router-dom";
import { Callout, H1 } from "atoms";
// import { isDev } from "config";
import { useAuth } from "features/auth";
import { Head } from "features/misc";
import {
  useProfilePoints,
  useUpdateProfile,
  useResetStagingProfileBalance,
  useStagingAirDropPoints,
} from "features/profile";
import { api } from "utils/api";
import { useNewNotifications } from "features/notifications/api/useNotifications";

const testNotification = () => api("/profile/stagingNotificationTest");

function Dev() {
  const { user, isLoading } = useAuth();
  const { newNotifications, count, markReadById } = useNewNotifications();

  const { updateProfile, ...updateMutation } = useUpdateProfile();
  const { data: balance } = useProfilePoints();

  const { mutate, ...resetMutation } = useResetStagingProfileBalance();
  const { airDrop, ...airDropMutation } = useStagingAirDropPoints();

  // if (!isDev) {
  //   return <Navigate to="/" replace />;
  // }

  const grantLevel1 = () => {
    if (user) {
      updateProfile({ ...user, completedLevel1Training: true });
    }
  };
  const grantLevel2 = () => {
    if (user) {
      updateProfile({ ...user, completedLevel2Training: true });
    }
  };
  const grantLevel3 = () => {
    if (user) {
      updateProfile({ ...user, completedLevel3Training: true });
    }
  };

  return (
    <Callout>
      <Head title="Dev Tools" />

      <H1>Dev Mode</H1>

      <h2>Your Profile</h2>
      <p>auth loading: {isLoading.toString()}</p>
      <p>id: {user?.id}</p>
      <p>roles: {user?.roles.join(", ")}</p>
      <p>balance: {JSON.stringify(balance)}</p>

      <hr />

      <button type="button" onClick={grantLevel1}>
        grant hugger (curator level 1) role
      </button>
      <button type="button" onClick={grantLevel2}>
        grant jr. curator (curator level 2) role
      </button>
      <button type="button" onClick={grantLevel3}>
        grant curator (curator level 3) role
      </button>

      <p>update status: {updateMutation.status}</p>

      <hr />

      <button type="button" onClick={() => airDrop(10)}>
        air drop 10 points
      </button>
      <button type="button" onClick={() => airDrop(50)}>
        air drop 50 points
      </button>
      <button type="button" onClick={() => airDrop(100)}>
        air drop 100 points
      </button>
      <button type="button" onClick={() => airDrop(1000)}>
        air drop 1000 points
      </button>

      <p>update status: {airDropMutation.status}</p>

      <hr />

      <button type="button" onClick={() => mutate()}>
        reset profile balance
      </button>

      <p>reset status: {resetMutation.status}</p>

      <hr />

      <h2>Notifications {!!count && count}</h2>
      <ol>
        {newNotifications.map((n, i) => (
          <li key={n.notificationId}>
            {n.message} -{" "}
            <button
              type="button"
              onClick={() => markReadById(n.notificationId)}
            >
              x
            </button>
          </li>
        ))}
      </ol>

      <button type="button" onClick={testNotification}>
        test notification
      </button>
    </Callout>
  );
}

export { Dev };
